import { Button } from '@/components/ui/button';
import { Plus, MapPin, Trash2 } from 'lucide-react';

export default function AlgaeTableActions({
  onAddOrganism,
  onEditSchema,
  onCancel,
  onDelete,
  completionPercentage,
  selectedArea,
  isEditing
}) {
  const isComplete = completionPercentage === 100;

  return (
    <div className="p-4 border-t-2 border-slate-200 bg-gradient-to-r from-slate-50 to-blue-50">
      <div className="flex justify-between items-center flex-wrap gap-4">
        {/* Left side - Add buttons and progress */}
        <div className="flex items-center flex-wrap gap-4">
          <Button
            onClick={onAddOrganism}
            size="sm"
            className="bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white shadow-md"
          >
            <Plus className="w-4 h-4 mr-2" />
            Legg til organisme (rad)
          </Button>
          
          <Button
            onClick={onEditSchema}
            variant="outline"
            size="sm"
            className="border-2 border-teal-300 text-teal-600 hover:bg-teal-50"
          >
            <MapPin className="w-4 h-4 mr-2" />
            Rediger skjema
          </Button>
          
          {/* Completion indicator */}
          <div className="flex items-center gap-3">
            <div className="text-sm text-slate-600">
              <span className="font-semibold">Fremdrift:</span> {completionPercentage}% 
            </div>
            <div className="w-32 h-2 bg-slate-200 rounded-full overflow-hidden">
              <div 
                className="h-full bg-gradient-to-r from-teal-500 to-blue-500 transition-all duration-300"
                style={{ width: `${completionPercentage}%` }}
              />
            </div>
            {isComplete && (
              <span className="text-sm text-green-600 font-semibold">Klar for sending</span>
            )}
          </div>
          
          {/* Color legend */}
          <div className="hidden lg:flex items-center gap-4 text-xs">
            <div className="flex items-center gap-1">
              <div className="w-4 h-4 bg-emerald-100 border border-emerald-300 rounded" />
              <span className="text-slate-600">Standard (grønn)</span>
            </div>
            <div className="flex items-center gap-1">
              <div className="w-4 h-4 bg-amber-100 border border-amber-300 rounded" />
              <span className="text-slate-600">Manuell gul</span>
            </div>
            <div className="flex items-center gap-1">
              <div className="w-4 h-4 bg-red-100 border border-red-300 rounded" />
              <span className="text-slate-600">Manuell rød</span>
            </div>
          </div>
        </div>
        
        {/* Right side - Delete and Cancel */}
        <div className="flex gap-3">
          {onDelete && (
            <Button
              onClick={onDelete}
              variant="outline"
              className="text-red-500 border-red-200 hover:bg-red-50 hover:border-red-300"
            >
              <Trash2 className="w-4 h-4 mr-1.5" />
              Slett skjema
            </Button>
          )}
          <Button onClick={onCancel} variant="outline">
            Avbryt
          </Button>
        </div>
      </div>
    </div>
  );
}
